/**
 * plugin interface for picture in picture.
 * @interface
 */
export class IPictureInPicturePlugin {
  constructor({ pipa } = {}) {
    this.pipa = pipa;
  }
  afterInsert({ overlay }) {
    // console.log({
    //   overlay,
    //   class: this.constructor.name,
    // }, 'been afterInsert');
  }
  afterReplaceOverlay() {}
  delete() {
    // console.log({
    //   class: this.constructor.name,
    // }, 'been delete');
  }
}
